import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
// import * as jquery from 'jquery';

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LfsaComboBoxV3Component),
  multi: true
};

@Component({
  selector: 'app-lfsa-combo-box-v3',
  templateUrl: './lfsa-combo-box-v3.component.html',
  styleUrls: ['./lfsa-combo-box-v3.component.css'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class LfsaComboBoxV3Component implements OnInit, ControlValueAccessor {

  @Output() ejecutarEvento = new EventEmitter<any>();
  @Input() innerValue: any;

  @Input() id: string;
  @Input() label: string;
  @Input() claseLabel = '';
  @Input() rutaImagen: string = '';
  @Input() mostrarImg = false;

  @Input() comboBox: any[] = [];
  @Input() idOpcion: string;
  @Input() opcion: string;

  @Input() habilitar: boolean;
  @Input() control: any;

  exampleData: Array<{ id: any; text: string }> = [];


  constructor() {

   }

   ngOnInit(): void {
    // const $this = this;
    // jquery(document).ready(() => {
    //   jquery(`#${this.id}`).select2();
    //   jquery(`#${this.id}`).attr('disabled','disabled');
    // });
      this.exampleData = this.comboBox.map( e => {
        e.id   = e[this.idOpcion];
        e.text = e[this.opcion];
        return e;
      });
   }

  get value() {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCb(v);
    }
  }

  // private _value: string;
  // get value(): string {
  //   return this.innerValue;
  // }
  // set value(value: string) {
  //   console.log('Set value: ' + value);
  //   this.innerValue = value;
  // }

  public changeValue() {
    this.innerValue = 'car2';
  }


  onChangeCb: (_: any) => void = () => { };
  onTouchedCb: (_: any) => void = () => { };

  writeValue(v: any): void {
    this.value = v;
  }

  registerOnChange(fn: any): void {
    this.onChangeCb = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCb = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // this.isReadOnly = isDisabled;
  }

  // public valueChanged(event: string) {
  //   console.log('value changed: ' + event);
  // }

  public modelChanged(event: string) {
    // console.log('model changed: ' + event);
    setTimeout(() => {
      this.ejecutarEvento.emit();
    }, 500);
  }

}
